import { memo } from '@morphic-ts/common/es6/utils';
import { either } from 'fp-ts/Either';
import { pipe } from 'fp-ts/es6/function';
import * as t from 'io-ts';
import { DateFromISOString } from 'io-ts-types/es6/DateFromISOString';
import { either as Teither } from 'io-ts-types/es6/either';
import { option as Toption } from 'io-ts-types/es6/option';
import { optionFromNullable } from 'io-ts-types/es6/optionFromNullable';
import { readonlyNonEmptyArray } from 'io-ts-types/es6/readonlyNonEmptyArray';
import { UUID } from 'io-ts-types/es6/UUID';
import { iotsApplyConfig } from '../config';
import { IOTSType, IoTsURI } from '../hkt';
/**
 *  @since 0.0.1
 */
export const BigIntString = new t.Type('BigIntString', 
// tslint:disable-next-line: strict-type-predicates valid-typeof
(u) => u !== undefined && u !== null && typeof u === 'bigint', (u, c) => either.chain(t.string.validate(u, c), s => {
    try {
        const d = BigInt(s);
        return t.success(d);
    }
    catch (_b) {
        return t.failure(u, c);
    }
}), a => a.toString(10));
const tag = (s) => new t.Type(s, (u) => u === s, (_i, _c) => t.success(s), _a => undefined);
/**
 *  @since 0.0.1
 */
/* istanbul ignore next */
export const ioTsPrimitiveInterpreter = memo(() => ({
    _F: IoTsURI,
    date: config => env => new IOTSType(iotsApplyConfig(config)(DateFromISOString, env, {})),
    boolean: config => env => new IOTSType(iotsApplyConfig(config)(t.boolean, env, {})),
    string: config => env => new IOTSType(iotsApplyConfig(config)(t.string, env, {})),
    number: config => env => new IOTSType(iotsApplyConfig(config)(t.number, env, {})),
    bigint: config => env => new IOTSType(iotsApplyConfig(config)(BigIntString, env, {})),
    stringLiteral: (l, config) => env => new IOTSType(iotsApplyConfig(config)(t.literal(l, l), env, {})),
    numberLiteral: (l, config) => env => new IOTSType(iotsApplyConfig(config)(t.literal(l, `${l}`), env, {})),
    oneOfLiterals: (l, config) => env => new IOTSType(iotsApplyConfig(config)(t.union(l.map(_ => t.literal(_))), env, {})),
    // oneOfLiterals: (l, config) => env => new IOTSType(iotsApplyConfig(config)(t.keyof(makeObj(l)), env, {})),
    tag: (l, config) => env => new IOTSType(iotsApplyConfig(config)(tag(l), env, {})),
    keysOf: (k, config) => env => new IOTSType(iotsApplyConfig(config)(t.keyof(k), env, {})),
    nullable: (T, config) => env => pipe(T(env).type, type => new IOTSType(iotsApplyConfig(config)(optionFromNullable(type), env, { type }))),
    optional: (T, config) => env => pipe(T(env).type, type => new IOTSType(iotsApplyConfig(config)(t.union([type, t.undefined]), env, { type }))),
    mutable: (T, config) => env => pipe(T(env).type, type => new IOTSType(iotsApplyConfig(config)(type, env, { type }))),
    array: (T, config) => env => pipe(T(env).type, type => new IOTSType(iotsApplyConfig(config)(t.readonlyArray(type), env, { type }))),
    nonEmptyArray: (T, config) => env => pipe(T(env).type, type => new IOTSType(iotsApplyConfig(config)(readonlyNonEmptyArray(type), env, { type }))),
    uuid: config => env => new IOTSType(iotsApplyConfig(config)(UUID, env, {})),
    either: (e, a, config) => env => ((left, right) => new IOTSType(iotsApplyConfig(config)(Teither(left, right), env, { left, right })))(e(env).type, a(env).type),
    option: (T, config) => env => pipe(T(env).type, type => new IOTSType(iotsApplyConfig(config)(Toption(type), env, { type }))),
    unknownE: (a, config) => env => new IOTSType(iotsApplyConfig(config)(a(env).type, env, {}))
}));
